import moment from 'moment'
export default {
  secondsToHMS: (seconds) => {
    const date = new Date(null)
    date.setSeconds(Math.floor(seconds))
    return date.toISOString().substr(11, 8)
  },

  secondsToISO8601HMS: (seconds) => {
    const date = new Date(null)
    date.setSeconds(Math.floor(seconds))
    let isoDate = date.toISOString().substr(11, 8)
    // isoDate = 'T'+ isoDate.replace(':', 'H').replace(':', 'M') + 'S';

    return isoDate
  },

  secondsToISO8601Duration: (seconds) => {
    let secondsInt = Math.floor(seconds * 1000)
    let duration = moment.duration(secondsInt)
    let ISO8601 = duration.toIsoString()
    return ISO8601
  },

  dateToYMD: (value, separator = '-') => {
    const date = new Date(value)
    const month = date.getUTCMonth() + 1
    const day = date.getUTCDate()
    const year = date.getUTCFullYear()

    return [year, month, day].join(separator)
  },

  secondsToHms: (d) => {
    d = Number(d)
    var h = Math.floor(d / 3600)
    var m = Math.floor((d % 3600) / 60)
    var s = Math.floor((d % 3600) % 60)

    function minutes(m) {
      let minutes
      if (m > 0 && m < 10) {
        minutes = '0' + m + ':'
      } else if (m === 0) {
        minutes = '00:'
      } else {
        minutes = m + ':'
      }
      return minutes
    }

    function seconds(s) {
      let seconds
      if (s > 0 && s < 10) {
        seconds = '0' + s
      } else if (s === 0) {
        seconds = '00'
      } else {
        seconds = s
      }
      return seconds
    }

    var hDisplay = h > 0 ? h + ':' : ''
    var mDisplay = minutes(m)
    var sDisplay = seconds(s)

    return hDisplay + mDisplay + sDisplay
  },
}
